import { ReactElement } from 'react'

import type { AlignType } from '@rc-component/trigger/lib/interface'
import { Popover, PopoverProps } from 'antd'
import classNames from 'classnames'

import * as styles from './styles.scss'

const CustomPopover = ({
    children,
    className,
    ...rest
}: PopoverProps & { align?: AlignType }): ReactElement => (
    <div className={classNames(styles['popover-wrapper'], className)}>
        <Popover {...rest}>{children}</Popover>
    </div>
)

export default CustomPopover
